import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const rootSx: SxProps<Theme> = {
    position: 'relative',
};

export const titleSx: SxProps<Theme> = {
    marginBottom: theme.spacing(20 / 8),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
};

export const editBtnSx: SxProps<Theme> = {
    position: 'absolute',
    top: 3,
    right: 0,
    background: 'transparent',
};

/**
 * The signature's space, held whether or not the signature has arrived.
 *
 * It comes from its own request, later than the page around it, and sized itself to whatever image
 * turned up - so the dashboard settled, then pushed everything below the signature down a second
 * later. A box of its own means the image fits into the page rather than the page around the image.
 */
export const canvasWrapperSx: SxProps = {
    height: 160,
    background: theme.palette.neutral[50],
    '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
};
